/* Apres Tennis: show only product photos matching the selected colour (matched via image alt text) */
(function () {
  function selectedColor(root) {
    var r = root.querySelector('variant-radios fieldset input:checked');
    if (r) return r.value;
    var s = root.querySelector('variant-selects select');
    return s ? s.value : null;
  }
  function matchesAlt(alt, colorLower, any) {
    var a = (alt || '').toLowerCase();
    var shared = a.indexOf('wszystkie kolory') !== -1;
    return shared || !any || a.indexOf(colorLower) !== -1;
  }
  function elementAlt(el) {
    if (!el || !el.getAttribute) return '';
    if (el.hasAttribute('data-media-alt')) return el.getAttribute('data-media-alt') || '';
    if (el.alt) return el.alt;
    var img = el.querySelector && el.querySelector('[data-media-alt], img[alt]');
    if (!img) return '';
    return img.getAttribute('data-media-alt') || img.getAttribute('alt') || '';
  }
  function filterZoom(root, colorLower, any) {
    var section = root.closest('[data-section]') || root.closest('section');
    if (!section) return;
    var sectionId = section.getAttribute('data-section') || '';
    var modal = sectionId ? document.getElementById('ProductModal-' + sectionId) : null;
    if (!modal) return;
    var content = modal.querySelector('.product-media-modal__content');
    if (!content) return;
    var firstMatch = null;
    var activeHidden = false;
    Array.prototype.forEach.call(content.children, function (el) {
      if (!el || el.nodeType !== 1 || !el.getAttribute) return;
      if (!el.hasAttribute('data-media-id') && !el.hasAttribute('data-media-alt') && !el.querySelector('[data-media-id], img')) return;
      var show = matchesAlt(elementAlt(el), colorLower, any);
      if (show) {
        el.style.removeProperty('display');
        if (!firstMatch) firstMatch = el;
      } else {
        el.style.setProperty('display', 'none', 'important');
        if (el.classList.contains('active')) activeHidden = true;
      }
    });
    if (activeHidden && firstMatch) {
      Array.prototype.forEach.call(content.children, function (el) {
        if (el && el.classList) el.classList.remove('active');
      });
      firstMatch.classList.add('active');
      if (modal.hasAttribute('open')) firstMatch.scrollIntoView();
    }
  }
  function filter(root) {
    var color = selectedColor(root);
    var items = root.querySelectorAll('.product__media-list [data-media-alt]');
    if (!color || !items.length) return;
    var c = color.toLowerCase();
    var any = false;
    items.forEach(function (li) { if ((li.dataset.mediaAlt || '').toLowerCase().indexOf(c) !== -1) any = true; });
    items.forEach(function (li) {
      var alt = (li.dataset.mediaAlt || '').toLowerCase();
      var shared = alt.indexOf('wszystkie kolory') !== -1;
      var match = shared || !any || alt.indexOf(c) !== -1;
      li.style.display = match ? '' : 'none';
    });
    var thumbs = root.querySelectorAll('.thumbnail-list [data-target]');
    thumbs.forEach(function (t) {
      var target = root.querySelector('[data-media-id="' + t.dataset.target + '"]');
      if (target) t.style.display = target.style.display;
    });
    filterZoom(root, c, any);
  }
  function rootOf(el) { return el.closest('.product') || el.closest('section') || document; }
  function all() { document.querySelectorAll('.product').forEach(filter); }
  document.addEventListener('change', function (e) {
    if (e.target.closest('variant-radios, variant-selects')) {
      var root = rootOf(e.target);
      filter(root);
      setTimeout(function () { filter(root); }, 50);
    }
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('modal-opener')) return;
    filter(rootOf(e.target));
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches('.product__media-list, .product') || n.querySelector('.product__media-list'))) { setTimeout(all, 50); return; }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
